import querystring from 'querystring'
import _ from 'lodash'

import { getTreeNodes, getLabel } from '../parameters'

export const buildAdUrl = (ad) => {
  if (!ad) {
    return
  }

  const region = ad.location[0].name
    .toLowerCase()
    .replace(/[åä]/g, 'a')
    .replace(/ö/g, 'o')

  const subject = ad.subject
    .toLowerCase()
    .replace(/[åä]/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/\W/g, '_')

  return `/annons/${region}/${subject}/${ad.adId}`
}

export const buildListUrl = (query, parametersByQueryKey) => {
  let category = ''
  let region = 'hela_sverige'

  if (query.r) {
    region = getLabel(parametersByQueryKey.r, { r: String(query.r) })
  }

  if (query.cg) {
    let categoryNodes = getTreeNodes(parametersByQueryKey.cg, { cg: query.cg })
    // Slice off the "alla kategorier" node
    categoryNodes = categoryNodes.slice(1)

    const categoryLabels = categoryNodes.map((node) => node.label)
    category = `/${categoryLabels.join('/')}`
  }

  let url = `/annonser/${region}${category}`
    .toLowerCase()
    .replace(/&/g, '')
    .replace(/ +/g, '_')
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')

  const queryWithoutEmptyValues = _.pickBy(query)

  if (!_.isEmpty(queryWithoutEmptyValues)) {
    url += `?${querystring.stringify(queryWithoutEmptyValues)}`
  }

  return url
}

/**
 * This function enables testing for window.location.href
 */
const getCurrentUrl = () => window.location.href

export default getCurrentUrl
